import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormItemComponentInterface} from '../../../../interface/component';
import {NoosFormTypeService} from '../../../../class/NoosFormTypeService';
import {IFormItemsControls} from '../../../../interface/form-structure';

@Component({
    selector: 'noos-email',
    templateUrl: './email.component.html',
    styleUrls: ['./email.component.scss']
})
@NoosFormTypeService.register('email')
export class EMailComponent implements OnInit, AfterViewInit, FormItemComponentInterface {

    prop: IFormItemsControls;

    @Output()
    keyOnEnter: EventEmitter<any> = new EventEmitter<any>();

    @Input()
    datasetId = 0;

    @Input()
    formId = 0;

    constructor() {
    }

    ngOnInit() {
    }

    ngAfterViewInit(): void {
    }


    emailValidator(value) {
        const test = (this.prop.requared && value !== '') &&
            (value !== '' && /^[_a-z0-9]+(\.[_a-z0-9]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,4})$/.test(value));
        return !test;
    }

}
